//@ts-ignore
import Flights from "./Flights";

export default Flights;
